import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, normalizeStyle as _normalizeStyle, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, isRef as _isRef, Teleport as _Teleport, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ac5eeb7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wizard-wrapper" }
const _hoisted_2 = { class: "container font-bold mx-auto px-40" }
const _hoisted_3 = { class: "flex flex-row text-xs xl:text-base" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-4 xl:ml-10" }, ">", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-4 xl:ml-10" }, ">", -1))
const _hoisted_6 = { class: "w- mt-10 bg-gray-200 rounded-full h-1 dark:bg-gray-700" }
const _hoisted_7 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_8 = { class: "scrollContainer" }
const _hoisted_9 = {
  key: 1,
  class: "hidden md:block arrow-container"
}

import Footer from '@/components/common/Footer.vue'
import LoadingBox from '@/components/zoom-diagnostic/Loading.vue'
import ControlButton from '@/components/room/ControlButton.vue'
import GetStarted from '@/components/zoom-diagnostic/GetStarted.vue'
import CheckPermissions from '@/components/zoom-diagnostic/CheckPermissions.vue'
import PermissionError from '@/components/zoom-diagnostic/PermissionError.vue'
import CameraTest from '@/components/zoom-diagnostic/CameraTest.vue'
import AudioTest from '@/components/zoom-diagnostic/AudioTest.vue'
import AudioTestRoom from '@/components/video-diagnostic/AudioTest.vue'
import Connectivity from '@/components/zoom-diagnostic/Connectivity.vue'
import Result from '@/components/zoom-diagnostic/Result.vue'
import ZoomDisconnectPopup from '@/components/room/ZoomDisconnectPopup.vue'
import NoAccessPopup from '@/components/room/NoAccessPopup.vue'
import {
  useConnection,
  zoomDiagnosticDisconnect,
} from '@/composables/zoom-diagnostic/useConnection'
import { permissions } from '@/composables/video-diagnostic/useCheckPermissions'
import { IUpdateTopic } from '@/types/interfaces/video-diagnostic.interface'
import { Stage, Topic } from '@/types/enums/zoom-diagnostic.enum'
import { useRoute, useRouter } from 'vue-router'
import { reactive, ref, onMounted, watch, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import CommonState from '@/services/locale-state'
import useAuth, { getToken } from '@/composables/api/useAuth'
import { isIOSMobile } from '@/helpers/zoom-device.helper'
import { useRoomStore } from '@/stores'
import { catchJson } from '@/helpers/transform.helper'


export default /*#__PURE__*/_defineComponent({
  __name: 'ZoomDiagnostic',
  setup(__props) {

const i18n = useI18n()
const route = useRoute()
const roomStore = useRoomStore()
const router = useRouter()
const { loginWithToken } = useAuth()

const topic = reactive({
  deviceSetup: false,
  connectivity: false,
  quality: false,
  results: false,
})
const stage = ref(0)
const supportedBrowser = ref(true)
const isInProgress = ref(true)
const finishedTest = ref(false)
const isLoading = ref(false)
const isMainEngine = ref(false)
const isIOS = ref(false)
const isNoToken = ref(false)
const header = computed(() => i18n.t('zoom-diagnostic.test-are-done'))
const message = computed(() => i18n.t('zoom-diagnostic.wait-report'))

let stopWatchStage

stopWatchStage = watch(stage, (stage) => {
  if (stage === Stage.RESULTS) {
    finishedTest.value = true
    isLoading.value = true
    setTimeout(() => {
      isLoading.value = false
      const objDiv = document.getElementById('scrollContainer')
      objDiv.scrollTop = objDiv.scrollHeight
      stopWatchStage()
    }, 1500)
  }
})

watch(isLoading, () => {
  setTimeout(() => {
    const objDiv = document.getElementById('scrollContainer')
    const footer = document.getElementById('footer')
    objDiv.scrollTop = objDiv.scrollHeight
    /**
     * scroll to result header after get the result
     */
    if (objDiv && footer && topic.results) {
      objDiv.scrollTop = objDiv.scrollHeight - (objDiv.offsetHeight + footer.offsetHeight)
    }
  }, 20)
})

const scrollDown = (id: number) => {
  stage.value = id
  const el = document.getElementById(`${id}`)
  const firstEl = document.getElementById('0')
  if (el) {
    const offset =
      id === Stage.RESULTS
        ? firstEl.offsetTop + firstEl.offsetHeight * 0.5
        : el.offsetTop + el.offsetHeight * 0.5
    const isMobile = screen.width <= 640
    if (el?.parentElement) {
      el.parentElement.style.transform = isMobile
        ? 'none'
        : `translateY(calc(50vh - ${offset}px + 50px))`
    }
  }
}

const updateTopic = (value: IUpdateTopic) => {
  switch (value.topic) {
    case Topic.DEVICE_SETUP:
      if (value.active) {
        topic.deviceSetup = true
      } else {
        topic.deviceSetup = false
      }
      break
    case Topic.CONNECTIVITY:
      if (value.active) {
        topic.connectivity = true
      } else {
        topic.connectivity = false
      }
      break
    case Topic.RESULTS:
      if (value.active) {
        topic.results = true
      } else {
        topic.results = false
      }
      break
  }
}

const setLanguage = () => {
  if (route.query.language) {
    switch (route.query.language) {
      case 'th': {
        CommonState.setLocale('th')
        i18n.locale.value = 'th'
        break
      }
      case 'vn': {
        CommonState.setLocale('vn')
        i18n.locale.value = 'vn'
        break
      }
      case 'en': {
        CommonState.setLocale('en')
        i18n.locale.value = 'en'
        break
      }
    }
  }
}

const setCountry = () => {
  if (route.query.country) {
    switch (route.query.country) {
      case 'th': {
        CommonState.setCountry('th')
        break
      }
      case 'vn': {
        CommonState.setCountry('vn')
        break
      }
    }
  }
}

onMounted(async () => {
  isIOS.value = isIOSMobile()
  setLanguage()
  setCountry()
  scrollDown(0)
  if (!route.query.token) {
    if (getToken()) {
      await roomStore.connect()
    } else {
      isNoToken.value = true
    }
  } else {
    const res = await loginWithToken(route.query.token as string)
    if (res.status === 200) {
      await roomStore.connect()
    } else {
      const errorData = catchJson(res.message?.error)
      const timeAttend = errorData?.now
      const message = res.message?.message
      router.push({
        name: 'join-fail',
        query: {
          from: location.href,
          code: res.message?.statusCode,
          timeAttend,
          message,
          error: res.message?.error,
          token: route.query.token,
        },
      })
    }
  }
  isMainEngine.value = roomStore.room.isMainEngine
  await useConnection({
    token: roomStore.token,
    roomName: roomStore.room.id,
    name: roomStore.localParticipantInfo?.name || '',
  })
})

return (_ctx: any,_cache: any) => {
  const _component_DefaultLayout = _resolveComponent("DefaultLayout")!

  return (_openBlock(), _createBlock(_component_DefaultLayout, {
    "have-navbar": "",
    "can-change-language": "",
    theme: "light",
    "have-engine": "",
    "is-main-engine": isMainEngine.value
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        id: "scrollContainer",
        class: _normalizeClass([finishedTest.value ? 'overflow-auto' : 'overflow-hidden', "h-screen"])
      }, [
        _createElementVNode("section", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: _normalizeClass([topic.deviceSetup ? 'opacity-100' : 'opacity-30', "mr-10 xl:mr-20"])
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t('zoom-diagnostic.device-software-setup')) + " ", 1),
                _hoisted_4
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass([topic.connectivity ? 'opacity-100' : 'opacity-30', "mr-10 xl:mr-20"])
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t('zoom-diagnostic.connectivity')) + " ", 1),
                _hoisted_5
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(topic.results ? 'opacity-100' : 'opacity-30')
              }, _toDisplayString(_ctx.$t('zoom-diagnostic.get-result')), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "bg-primary-color h-1 rounded-full duration-1000",
              style: _normalizeStyle(`width: ${(stage.value / _unref(Stage).RESULTS) * 100}%`)
            }, null, 4)
          ])
        ]),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(LoadingBox, {
                stage: _unref(Stage).CONNECTIVITY,
                header: header.value,
                message: message.value
              }, null, 8, ["stage", "header", "message"])
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", _hoisted_8, [
          _createVNode(GetStarted, {
            stage: stage.value,
            onNextStage: scrollDown
          }, null, 8, ["stage"]),
          _createVNode(CheckPermissions, {
            stage: stage.value,
            onNextStage: scrollDown,
            onUpdateTopic: updateTopic
          }, null, 8, ["stage"]),
          (!_unref(permissions))
            ? (_openBlock(), _createBlock(PermissionError, {
                key: 0,
                stage: stage.value
              }, null, 8, ["stage"]))
            : _createCommentVNode("", true),
          _createVNode(CameraTest, {
            stage: stage.value,
            onNextStage: scrollDown
          }, null, 8, ["stage"]),
          (!isIOS.value)
            ? (_openBlock(), _createBlock(AudioTest, {
                key: 1,
                stage: stage.value,
                onNextStage: scrollDown
              }, null, 8, ["stage"]))
            : _createCommentVNode("", true),
          (isIOS.value)
            ? (_openBlock(), _createBlock(AudioTestRoom, {
                key: 2,
                stage: stage.value,
                onNextStage: scrollDown
              }, null, 8, ["stage"]))
            : _createCommentVNode("", true),
          _createVNode(Connectivity, {
            stage: stage.value,
            onInprogress: _cache[0] || (_cache[0] = ($event: any) => (isInProgress.value = false)),
            onNextStage: scrollDown,
            onUpdateTopic: updateTopic
          }, null, 8, ["stage"]),
          (!isInProgress.value)
            ? (_openBlock(), _createBlock(Result, {
                key: 3,
                stage: stage.value,
                onNextStage: scrollDown,
                onUpdateTopic: updateTopic
              }, null, 8, ["stage"]))
            : _createCommentVNode("", true),
          (stage.value === _unref(Stage).RESULTS && topic.results)
            ? (_openBlock(), _createBlock(Footer, { key: 4 }))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, !isLoading.value]
        ]),
        (stage.value !== _unref(Stage).RESULTS)
          ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
              _createVNode(ControlButton, {
                class: _normalizeClass([stage.value === 0 ? 'opacity-0 pointer-events-none' : '', "arrow-container__button mb-4"]),
                icon: "line-arrow-up",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (
            scrollDown(
              _unref(permissions) && stage.value === _unref(Stage).CAMERA_TEST ? _unref(Stage).CHECK_PERMISSIONS : stage.value - 1,
            )
          ))
              }, null, 8, ["class"]),
              _createVNode(ControlButton, {
                class: _normalizeClass([
            [_unref(Stage).CHECK_PERMISSIONS, _unref(Stage).PERMISSION_ERROR, _unref(Stage).RESULTS].includes(stage.value) ||
            !supportedBrowser.value ||
            (isInProgress.value && stage.value === _unref(Stage).CONNECTIVITY)
              ? 'opacity-0 pointer-events-none'
              : ''
          , "arrow-container__button"]),
                icon: "line-arrow-down",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (scrollDown(stage.value + 1)))
              }, null, 8, ["class"])
            ]))
          : _createCommentVNode("", true),
        (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
          _createVNode(ZoomDisconnectPopup, {
            modelValue: _unref(zoomDiagnosticDisconnect),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(zoomDiagnosticDisconnect) ? (zoomDiagnosticDisconnect).value = $event : null)),
            "exit-path": _unref(roomStore).room.exitPath
          }, null, 8, ["modelValue", "exit-path"])
        ])),
        (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
          _createVNode(NoAccessPopup, {
            modelValue: isNoToken.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isNoToken).value = $event))
          }, null, 8, ["modelValue"])
        ]))
      ], 2)
    ]),
    _: 1
  }, 8, ["is-main-engine"]))
}
}

})